import HttpFactory from '~/api/http-factory'
import type { GetPickupPointsParams, GetPickupPointsResponse } from '~/types/pickup-points'

export default class PickupPoints extends HttpFactory {
  private readonly resource = 'v1/pickupPoints'

  public getPickupPoints (params: GetPickupPointsParams): Promise<GetPickupPointsResponse> {
    return this.$fetch(this.resource, { params })
  }
}
